// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessRefinery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.628 9.303a4.87 4.87 0 0 1 1.711.597c.261-2.508 2.141-4.51 4.53-4.85V4.5a.245.245 0 0 0-.24-.25h-5.76a.245.245 0 0 0-.24.25zm-1.44 0V4.5c0-.967.752-1.75 1.68-1.75h5.76c.928 0 1.68.783 1.68 1.75v.55c2.576.367 4.56 2.667 4.56 5.45v10a.49.49 0 0 1-.48.5H4.068a.49.49 0 0 1-.48-.5v-1c0-.276.215-.5.48-.5h1.243c-1.464-.919-2.443-2.59-2.443-4.5 0-2.645 1.878-4.833 4.32-5.197zm5.04 7.903V19h6.72v-8.5c0-1.933-1.504-3.5-3.36-3.5-1.855 0-3.36 1.567-3.36 3.5v1.294c.457.79.72 1.716.72 2.706a5.39 5.39 0 0 1-.72 2.706zm-4.32 1.044c1.988 0 3.6-1.679 3.6-3.75 0-2.071-1.612-3.75-3.6-3.75s-3.6 1.679-3.6 3.75c0 2.071 1.612 3.75 3.6 3.75z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessRefinery;
